import { lazy } from "react";

import { RouteAuth } from "@/_old/components/auth/route";

const WalletPage = lazy(() => import("@/billing/view"));

export function WalletRoute() {
  return (
    <RouteAuth>
      <WalletPage />
    </RouteAuth>
  );
}
